import React from 'react';
import Button from '@material-ui/core/Button';
import MuiIconButton from "../MuiIconButton/MuiIconButton";
import Translator from "../../Languages/Utility/Translator";
import * as Icons from 'react-bootstrap-icons';
import MuiButton from 'Components/MuiButton/MuiButton';
import { useTranslation } from 'react-i18next';

export default function MuiUpload({onChange, selectedFile, onDeleteFile}) {
    const { t } = useTranslation();
    return (
        <div className="uploader-component">
            {
                selectedFile ? 
                <div className="list">
                    <span>{t('selectedFile')}</span>
                    <div>
                        <p>{selectedFile?.name}</p>
                        <MuiIconButton
                            title={<Translator id={"delete"}/>}
                            icon={<Icons.Trash3 size={17} />}
                            className="danger-fill mx-1"
                            onClick={onDeleteFile}
                        />
                    </div>
                </div> :
                <>
                    <input
                        accept="image/*,application/pdf"
                        id="contained-button-file"
                        type="file"
                        style={{display: "none"}}
                        onChange={onChange}
                    />
                    <label htmlFor="contained-button-file" className='uploader-button'>
                        <Icons.CloudArrowUp /><Translator id="upload" />
                    </label>
                </>
            }
        </div>
    );
}
